/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DnsModule
 */

import { IDnsRuleMatchTarget } from 'generated-types';
import { DnsRuleMatchTarget } from 'object-types';

import { PolicyMatchConfigItem }
    from '../../policies/factories/config-items/policy-match.config-item.factory';
import { DnsClientIpMatchConfigItem }
    from './matches/dns-client-ip-match.config-item.factory';
import { DnsClientPortMatchConfigItem }
    from './matches/dns-client-port-match.config-item.factory';
import { DnsGeoLocationMatchConfigItem }
    from './matches/dns-geo-location-match.config-item.factory';
import { DnsTransportProtocolMatchConfigItem }
    from './matches/dns-transport-protocol-match.config-item.factory';
import { DnsQueryNameMatchConfigItem }
    from './matches/dns-query-name-match.config-item.factory';
import { DnsQueryTypeMatchConfigItem }
    from './matches/dns-query-type-match.config-item.factory';

type TDnsRuleMatchTargetPartial = Omit<IDnsRuleMatchTarget,
'client_ip_address' | 'client_port_numbers' | 'geo_location'
| 'protocol' | 'query_name' | 'query_type'>;

/**
 * Interface for Dns Rule Match Target Partial.
 */
interface IDnsRuleMatchTargetConfig extends TDnsRuleMatchTargetPartial {
    client_ip_address?: DnsClientIpMatchConfigItem;
    client_port_numbers?: DnsClientPortMatchConfigItem;
    geo_location?: DnsGeoLocationMatchConfigItem;
    protocol?: DnsTransportProtocolMatchConfigItem;
    query_name?: DnsQueryNameMatchConfigItem;
    query_type?: DnsQueryTypeMatchConfigItem;
}

/**
 * @description DnsRuleMatchTarget MessageItem class.
 * @author Abhinesh Gour
 */
export class DnsRuleMatchTargetConfigItem
    extends PolicyMatchConfigItem<IDnsRuleMatchTargetConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: DnsRuleMatchTarget,
            ...args,
        };

        super(extendedArgs);
    }
}
